export enum GatewaysColumnKeys {
  Health = 'health',
  LastSeenAt  = 'lastSeenAt', // api uses lastSeenAt instead of last_check_in
  Name = 'name',
  // Type = 'gatewayType',
  EUI = 'eui'
}
